module.exports = __webpack_public_path__ + "assets/img/1010.59ba257b.svg";